import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { DeviceSerialized, DeviceConnectionSerialized } from '@playq/octopus2-devices';
import { ClientEventSerialized } from '@playq/services-vortex';

import { deviceState } from './state';
import { baseSelectors, selectSubscriptionDevice } from './selectors';

const deviceSlice = createSlice({
  name: 'devices',
  initialState: deviceState,
  reducers: {
    setSubDevices: (state, action: PayloadAction<DeviceSerialized>) => {
      const device = action.payload;
      state.devices = [device];
    },
    unSubDevices: (state, action: PayloadAction<string>) => {
      const deviceId = action.payload;
      state.devices = state.devices.filter((device) => device.id !== deviceId);
    },
    updateSubscriptionName: (state, action: PayloadAction<{ id: string; name: string }>) => {
      state.devices = state.devices.map((item) => {
        if (item.id === action.payload.id) {
          return { ...item, name: action.payload.name };
        }
        return item;
      });
    },
    setEvents: (state, action: PayloadAction<{ id: string; event: ClientEventSerialized }>) => {
      state.streamEvents[action.payload.id] =
        state.streamEvents[action.payload.id] !== undefined
          ? [action.payload.event, ...state.streamEvents[action.payload.id]]
          : [action.payload.event];
    },
    updateConnection: (
      state,
      action: PayloadAction<{ id: string; connection: DeviceConnectionSerialized | undefined }>
    ) => {
      state.devices = state.devices.map((item) => {
        if (item.id === action.payload.id) {
          return { ...item, connection: action.payload.connection };
        }
        return item;
      });
    },
  },
});

export const deviceToolkit = Object.freeze({
  deviceState,
  actions: deviceSlice.actions,
  selectors: {
    ...baseSelectors,
    subscriptionDevice: selectSubscriptionDevice,
  },
});

export const deviceModuleReducer = deviceSlice.reducer;
